import { p as j, T as l } from "./eMyAsurionProvider-5bc36307.js";
import { H as V } from "./eMyAsurionProvider-5bc36307.js";
import { j as t } from "./jsx-runtime-944c88e2.js";
import { ArrowBackIcon as c, CloseIcon as g } from "@chakra-ui/icons";
import { useMediaQuery as y, Box as x, Button as d, Text as f } from "@chakra-ui/react";
import "react";
import "./useAccount-a03adfa5.js";
import "./myasurion-shared.mixpanel.es.js";
import "./features-979fdcf7.js";
import "@tanstack/react-query";
import "./providers-29a9425c.js";
import "react-router-dom";
import "./cleave-react-node-c4a374e5.js";
import "./lodash-9598aa3c.js";
import "@react-oauth/google";
import "./domains-7d097fe4.js";
import "./myasurion-shared.carrier.es.js";
import "framer-motion";
import "./myasurion-shared.widgets.es.js";
import "./myasurion-shared.utils.es.js";
import "./myasurion-shared.colors.es.js";
import "@emotion/react";
import "./ProfileIcon-8cf21b72.js";
import "./myasurion-shared.profile.es.js";
import "react-dom";
import "mixpanel-browser";
import "@emotion/styled";
const F = ({
  onClick: o,
  children: i,
  isProfile: p = !1,
  ...e
}) => {
  const [r] = y("(min-width: 768px)"), { updateHeaderIsOpen: n } = j();
  return /* @__PURE__ */ t.jsx(
    x,
    {
      w: "full",
      h: "48px",
      p: "16px 16px 8px 16px",
      boxShadow: "0px -1px 0px 0px #EBEBEB inset;",
      display: "flex",
      alignItems: "center",
      gap: "4px",
      ...e,
      children: /* @__PURE__ */ t.jsx(
        d,
        {
          variant: "link",
          colorScheme: "black",
          leftIcon: /* @__PURE__ */ t.jsx(c, {}),
          onClick: () => {
            !r && p ? n((s) => !s) : window.history.back(), o && o();
          },
          children: i || /* @__PURE__ */ t.jsx(f, { children: "Back" })
        }
      )
    }
  );
}, J = ({
  onClick: o,
  backText: i,
  cancelText: p,
  cancelTextKey: e = "CancelButton",
  onCancelClick: r,
  showBackButton: n,
  allowBackButtonClick: s,
  showCancelButton: m,
  disableGlobalPageName: u,
  ...h
}) => {
  const a = "Global";
  return /* @__PURE__ */ t.jsxs(
    x,
    {
      w: "full",
      h: "48px",
      p: "16px 16px 8px 16px",
      display: "flex",
      alignItems: "flex-start",
      gap: "4px",
      ...h,
      children: [
        /* @__PURE__ */ t.jsx(
          d,
          {
            display: n ? "flex" : "none",
            justifyContent: "left",
            variant: "link",
            colorScheme: "black",
            fontWeight: "normal",
            marginY: "auto",
            leftIcon: /* @__PURE__ */ t.jsx(c, {}),
            onClick: () => {
              s && window.history.back(), o && o();
            },
            children: i && /* @__PURE__ */ t.jsx(l, { text: i, translationKey: `${a}/BackButton` })
          }
        ),
        /* @__PURE__ */ t.jsxs(
          x,
          {
            display: m ? "flex" : "none",
            justifyContent: "right",
            width: "100%",
            children: [
              /* @__PURE__ */ t.jsx(
                f,
                {
                  variant: "link",
                  cursor: "pointer",
                  onClick: () => r && r(),
                  children: p && /* @__PURE__ */ t.jsx(
                    l,
                    {
                      text: p,
                      translationKey: `${u ? "Disabled" + a : a}/${e}`
                    }
                  )
                }
              ),
              /* @__PURE__ */ t.jsx(
                g,
                {
                  onClick: () => r && r(),
                  display: m ? "block" : "none",
                  cursor: "pointer",
                  alignSelf: "center",
                  marginX: "0.5rem",
                  padding: "1px"
                }
              )
            ]
          }
        )
      ]
    }
  );
};
export {
  F as BackButton,
  V as Header,
  J as SubHeader
};
